import { myCompanyApi } from '../../b2b/features/company/api';
import { walletApi } from '../../b2b/features/wallet/api';
import { b2bAuthApi } from '../../b2b/features/auth/api';

export const b2bApi = {
  ...myCompanyApi,
  ...walletApi,
  ...b2bAuthApi,
};
